<template>
  <div>
    <header-ton @boxLogin="IsUsersLogin"></header-ton>
    <login-box :showLogin="showLogin" @closeLogin="closeBox" ref="login"></login-box>
    <div class="box_one" v-loading.fullscreen.lock="fullscreenLoading">

      <div class="list">
        <div class="thumb"><img class="icon" :src="dataInfo.thumb" height="220" width="220" /></div>
        <div class="desc">
          <div class="title"><span></span>{{ dataInfo.title }}</div>
          <div class="tags">{{ dataInfo.desc }}</div>
          <p class="book-zbjcOne-rtGmqb-hd">选择购买：</p>

          <div class="book-zbjcOne-rtM3">
            <ul class="book-zbjcOne-rtM3-ul">

              <li :class="item.checked == true ?'on':''" @click="changeGoodAttrs(item.id,index)" v-for="(item,index) in attrData" :key="index">
                <p class="book-zbjcOne-rtM3-liWz">{{ item.title }}</p> <span class="book-zbjcOne-rtM3-liCheck"></span>
                <div class="book-zbjcOne-rtM3-liRt">
                  <p class="book-zbjcOne-rtM3-liRt-t"><i class="book-zbjcOne-rtM3-liRt-nowPrice">¥<em>{{item.price}}</em></i></p>
                  <p class="book-zbjcOne-rtM3-liRt-b"><i class="book-zbjcOne-rtM3-liRt-oldPrice">定价￥{{item.yprice}}</i></p>
                </div>
              </li>

            </ul>
          </div>

          <div class="bottoms">
            <div class="left"></div>
            <div class="right">
              <div class="book-zbjcOne-gmPrice" style="">
                <div class="book-zbjcOne-gmNow-price">合计: <i>¥<em>{{price}}</em></i></div>
                <div class="book-zbjcOne-gmOld-price">定价:<i>¥{{yprice}}</i></div>
              </div>
              <div class="btns" @click="goSumbit()">去结算</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="detail">
      <div class="l_left">
        <div class="l_title">详情介绍</div>
        <div class="l_desc" v-html="dataInfo.content"></div>
      </div>
      <div class="l_right">
        <div class="box1">
          <div class="r_title">移动端设备学习</div>
          <div class="r_thumb"><img class="icon" src="../../../public/images/bg/9.png" height="320" width="100%" /></div>
          <div class="r_desc">扫描二维码进入小程序</div>
        </div>
        <div class="box1" v-if="goods">
          <div class="r_title">课程推荐</div>
          <div class="r_thumb"><img class="icon" :src="goods.thumb" height="320" width="100%" /></div>
          <div class="g_title">{{goods['title']}}</div>
          <div class="g_desc">{{goods['desc']}}</div>
          <div class="g_price">￥{{goods['money']}}</div>
          <div class="g_buttom" @click="goDetail(goods.id)">报名试听</div>
        </div>
      </div>
    </div>
    <booter-ton></booter-ton>
  </div>
</template>
  
  <script>
import HeaderTon from "@/components/HeaderTon";
import BooterTon from "@/components/BooterTon";
import LoginBox from "@/components/LoginBox";
export default {
  components: {
    HeaderTon,
    BooterTon,
    LoginBox,
  },
  data() {
    return {
      dataInfo: [],
      attrData: [],
      goods: [],
      good_id: 0,
      price: 0,
      yprice: 0,
      showLogin: false,
      fullscreenLoading: true,
      keywords: "",
    };
  },
  mounted() {
    var that = this;
    var query = that.$route.query;
    if (query.good_id) {
      that.good_id = query.good_id;
      that.getDetail();
    }
  },
  methods: {
    //判断是否登录
    IsUsersLogin() {
      let token = sessionStorage.getItem("access-token");
      console.log(token);
      if (token) {
        return true;
      } else {
        this.showLogin = true;
        this.$refs.login.getMiQrCode();
        return false;
      }
    },

    closeBox(e) {
      console.log(e);
      this.showLogin = false;
    },

    changeGoodAttrs(id, index) {
      if (!this.IsUsersLogin()) {
        return false;
      }

      let that = this;
      let formData = {};
      let ids = "";
      if (that.attrData[index]["checked"] == true) {
        that.attrData[index]["checked"] = false;
      } else {
        that.attrData[index]["checked"] = true;
      }
      that.attrData.forEach((element) => {
        if (element.checked == true) {
          ids += element.id + ",";
        }
      });
      formData.ids = ids;
      that.axios.post("/getPayPrice", formData).then((res) => {
        if (res) {
          that.price = Number(res.data.price).toFixed(2);
          that.yprice = Number(res.data.yprice).toFixed(2);
        }
      });
    },

    getDetail() {
      let that = this;
      let formData = {};
      formData.id = that.good_id;
      that.axios.post("/getGoodDetail", formData).then((res) => {
        if (res) {
          console.log(res.data.title);
          that.dataInfo = res.data;
          res.data.attrs.forEach((element) => {
            element["checked"] = false;
          });
          that.attrData = res.data.attrs;
          that.fullscreenLoading = false;
          that.goods = res.data.goods;
        }
      });
    },

    goDetail(ids) {
      this.$router.push({
        path: "/web/shop_detail",
        query: {
          good_id: ids,
        },
      });
    },

    goSumbit() {
      let that = this;
      let ids = "";
      that.attrData.forEach((element) => {
        if (element.checked == true) {
          ids += element.id + ",";
        }
      });
      console.log(ids);
      if (ids == "" || ids == null) {
        that.$message.warning("请选择您需要购买的科目，可多选！");
      } else {
        this.$router.push({
          path: "/payment/index",
          query: {
            good_id: that.good_id,
            attrs: ids.replace(/,([^,]*)$/, "$1"),
          },
        });
      }
    },
  },
};
</script>
  
  <style>
page {
  background: #f3f8ff;
}

.detail {
  width: 1200px;
  margin: 20px auto 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.detail .l_left {
  width: 68%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.detail .l_left .l_title {
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 22px;
  border-left: 3px solid #1167d4;
  margin: 20px 0;
  padding-left: 14px;
}

.detail .l_left .l_desc {
  padding: 25px;
  border-top: 1px solid #e5e5e5;
}

.detail .l_right {
  width: 30%;
  display: flex;
  flex-direction: column;
}

.detail .l_right .box1 {
  background: #ffffff;
  margin-bottom: 20px;
  padding: 20px;
}

.detail .l_right .box1 .r_title {
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 22px;
  border-left: 3px solid #1167d4;
  margin: 20px 0;
  padding-left: 14px;
}

.detail .l_right .box1 .r_thumb {
  width: 100%;
  height: 320px;
  margin-bottom: 10px;
}

.detail .l_right .box1 .r_desc {
  width: 100%;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #586a82;
  line-height: 42px;
}

.g_title {
  width: 100%;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 27px;
}
.g_desc {
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 27px;
}
.g_price {
  width: 100%;
  font-weight: bold;
  font-size: 24px;
  color: #df1c1c;
  line-height: 42px;
  border-bottom: 1px solid #e5e5e5;
}
.g_buttom {
  width: 134px;
  height: 38px;
  background: linear-gradient(90deg, #ff0e0e, #e23d29, #ff7b25);
  box-shadow: 0px 0px 6px 0px rgba(236, 84, 35, 0.5);
  border-radius: 19px;
  float: right;
  margin-top: 15px;
  text-align: center;
  line-height: 38px;
  color: #ffffff;
  cursor: pointer;
}

.box_one {
  width: 1200px;
  margin: 20px auto 0 auto;
  display: flex;
  flex-direction: column;
}

.box_one .list {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  padding: 30px;
  background: #ffffff;
}

.box_one .list .thumb {
  width: 220px;
  height: 220px;
  margin-right: 30px;
}

.box_one .list .desc {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 880px;
}

.box_one .list .desc .title {
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
}

.box_one .list .desc .title span {
  width: 4px;
  height: 18px;
  background: #1167d4;
  border-radius: 2px;
  margin-right: 6px;
  margin-top: 6px;
}

.box_one .list .desc .tags {
  height: 42px;
  line-height: 42px;
  color: #7f8ca2;
  font-size: 14px;
  border-bottom: 1px dashed #e0e0e0;
}

.box_one .list .desc .bottoms {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 98%;
  margin-top: 40px;
}

.box_one .list .desc .bottoms .left {
  width: 45%;
  display: flex;
  flex-direction: row;
}

.box_one .list .desc .bottoms .right .book-zbjcOne-gmPrice {
  display: inline-block;
  margin-right: 20px;
  width: 56%;
  text-align: right;
}

.book-zbjcOne-gmPrice > div,
.book-zbjcTwo-gmPrice > div {
  display: inline;
  font-size: 14px;
  color: #555;
}

.book-zbjcOne-gmNow-price > i,
.book-zbjcTwo-gmNow-price > i {
  font-size: 20px;
  color: #f92f2f;
  margin-left: 5px;
}

i,
em {
  font-style: normal;
}

.book-zbjcOne-gmNow-price > i > em,
.book-zbjcTwo-gmNow-price > i > em {
  font-size: 36px;
  font-weight: 900;
}

.book-zbjcOne-gmPrice .book-zbjcOne-gmOld-price,
.book-zbjcTwo-gmPrice .book-zbjcTwo-gmOld-price {
  font-size: 13px;
  text-decoration: line-through;
  color: #a0a0a0;
  margin-left: 5px;
}

.book-zbjcOne-rtGmqb-hd {
  font-size: 14px;
  color: #555;
  line-height: 36px;
}

.box_one .list .desc .bottoms .right {
  width: 55%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.box_one .list .desc .bottoms .right .btns {
  width: 180px;
  height: 52px;
  line-height: 42px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #ea2c18;
  font-size: 20px;
  box-shadow: 0 7px 27px rgba(234, 44, 24, 0.23);
}

.box_one .list .desc .bottoms .right .btns img {
  margin-left: 6px;
}

/** 选择框 */
.book-zbjcOne-rtM3 {
}
.book-zbjcOne-rtM3-ul {
  display: flex;
  flex-wrap: wrap;
}
.book-zbjcOne-rtM3-ul > li {
  min-width: 48%;
  min-height: 20px;
  padding: 3px 0;
  border: 1px solid #e0e0e0;
  margin-right: 12px;
  margin-bottom: 10px;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
/* .book-zbjcOne-rtM3-ul > li:nth-child(3n) {
  margin-right: 0;
} */
.book-zbjcOne-rtM3-liWz {
  margin-left: 40px;
  font-size: 14px;
  line-height: 38px;
  position: relative;
}
.book-zbjcOne-rtM3-liRt {
  width: 100px;
  text-align: center;
}
.book-zbjcOne-rtM3-liRt-nowPrice {
  font-size: 16px;
  color: #555;
}
.book-zbjcOne-rtM3-liRt-zk {
  font-size: 12px;
  color: #b0b0b0;
}
.book-zbjcOne-rtM3-liRt-oldPrice {
  font-size: 12px;
  color: #dedede;
  text-decoration: line-through;
}
.book-zbjcOne-rtM3-liRt-b {
  margin-top: -4px;
}

.book-zbjcOne-rtM3-ul > li.disabled:hover {
  border: 1px solid #e0e0e0;
  background: none;
  cursor: not-allowed;
}
.book-zbjcOne-rtMd2-select > li.on,
.on .book-zbjcOne-rtGmqb-bdWz,
.on .book-zbjcOne-rtM3-liWz,
.on .book-zbjcOne-rtM3-liRt-nowPrice,
.on .book-zbjcOne-rtM3-liRt-zk {
  color: #ea2c18;
  font-weight: bold;
}

.book-zbjcOne-rtM3-liCheck,
.on .book-zbjcTwo-rtM3-liCheck {
  width: 18px;
  height: 18px;
  background: url(../../../public/images/icon/no_selected.png) no-repeat 0px 0px;
  position: absolute;
  top: 50%;
  left: 11px;
  margin-top: -9px;
}

.on .book-zbjcOne-rtGmqb-bdCheck,
.on .book-zbjcOne-rtM3-liCheck,
.on .book-zbjcTwo-rtM3-liCheck {
  background: url(../../../public/images/icon/selected.png) no-repeat 0px 0px;
}

.book-zbjcOne-rtGmqb-bdItem:hover,
.book-zbjcOne-rtMd2-select > li:hover,
.book-zbjcOne-rtM3-ul > li:hover,
.book-zbjcOne-rtGmqb-bdItem.on,
.book-zbjcOne-rtMd2-select > li.on,
.book-zbjcOne-rtM3-ul > li.on {
  border-color: #f24431;
  background-color: #fffbfb;
}
</style>